import { PageHeader } from "@components";
import { Button } from "@components/button/button-untitledui";
import { Plus, Upload01 } from "@untitledui/icons";

type ExpensesPageHeaderProps = {
	subtitle?: string;
	onImport?: () => void;
	onNewExpense?: () => void;
};

export function ExpensesPageHeader({
	subtitle = "",
	onImport,
	onNewExpense,
}: ExpensesPageHeaderProps) {
	const hasActions = !!onImport || !!onNewExpense;

	return (
		<PageHeader
			actions={
				hasActions ? (
					<>
						{!!onImport && (
							<Button
								aria-label="Importar despesas"
								color="secondary"
								iconLeading={Upload01}
								onClick={onImport}
								size="sm"
							>
								Importar
							</Button>
						)}
						{!!onNewExpense && (
							<Button
								aria-label="Nova despesa"
								color="primary"
								iconLeading={Plus}
								onClick={onNewExpense}
								size="sm"
							>
								Nova despesa
							</Button>
						)}
					</>
				) : null
			}
			subtitle={subtitle || undefined}
			subtitleClassName="capitalize"
			title="Despesas da Frota"
		/>
	);
}
